import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import "./Styles/modal-component.scss";

const ModalComponent = (props = {}) => {
  const {
    data,
    styles,
    styleCloseContainer,
    styleCloseIcon,
    styleCloseText,
    closeText = `Close`,
    closeIcon,
    onClose,
    afterOpen,
    modalIsOpen,
    className,
    setModalIsOpen,
    showCloseIcon = false,
    showCloseText = true,
  } = props;

  const mainStyles = {
    overlay: {
      position: "fixed",
      inset: "0",
      backgroundColor: "rgba(109, 111, 241, 0.8)",
      zIndex: 1006,
    },
    content: {
      background: "transparent",
      border: "none",
      inset: "0px",
      position: "absolute",
      width: "60%",
      margin: "0 auto"
    },
  };

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-end",
    marginTop: "20px",
  };

  const closeIconStyle = {
    color: "red",
    fontSize: "1.5em",
  };

  const closeTextStyle = {
    color: "red",
    fontSize: "1.5em",
    marginLeft: "10px",
  };

  const afterOpenModal = () => {
    if (afterOpen) {
      afterOpen();
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const closeIconElement = (
    <div style={styleCloseContainer || closeContainerStyle}>
      {showCloseIcon ? (
        <FontAwesomeIcon
          style={styleCloseIcon || closeIconStyle}
          icon={closeIcon || faTimes}
          onClick={closeModal}
        ></FontAwesomeIcon>
      ) : null}
      {showCloseText ? <Button className="close-btn" onClick={closeModal}>{closeText}</Button> : null}
    </div>
  );
  return (
    <div className="modal-component">
      <Modal
        style={styles || mainStyles}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        ariaHideApp={false}
        className={className}
      >
        {closeIconElement}
        {data}
      </Modal>
    </div>
  );
};

export default ModalComponent;
